import type { RefObject } from 'react';

export const scrollToElementByRef = (ref: RefObject<HTMLElement | null> | undefined) => {
    if (ref?.current) {
        const headerOffset = 50;
        const elementPosition = ref.current.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    }
};

export const focusElementByRef = (ref: RefObject<HTMLElement | null> | undefined) => {
    if (ref?.current) {
        ref.current.focus({ preventScroll: true });
    }
};
